export enum EnumStatusPedido {
    AGUARDANDO_CONFIRMACAO = 1,
    CONFIRMADO = 2,
    EM_PREPARO = 3,
    ENVIADO = 4,
    FINALIZADOOUENTREGUE = 5,
    CANCELADO = 6,
    FECHADO = 7,
    IMPORTADO = 8,
}